<template>
  <form class="mailjet-form" @submit.prevent="sendMail">
    <template v-if="!success">
      <div class="form-group">
        <input
          id="toEmail"
          v-model="toEmail"
          type="email"
          required
          :placeholder="mailLabel"
        />
      </div>
      <div class="form-group">
        <input
          id="subject"
          v-model="subject"
          type="text"
          required
          :placeholder="subjectLabel"
        />
      </div>
      <div class="form-group">
        <textarea
          id="messagePersonel"
          v-model="messagePersonel"
          required
          rows="6"
          :placeholder="messageLabel"
        ></textarea>
      </div>
      <button type="submit" :disabled="loading">
        {{ loading ? sendingLabel : sendLabel }}
      </button>
    </template>
    <div v-if="success" class="success-message">
      {{ messageSendLabel || 'OK' }}
    </div>
    <div v-if="error" class="error-message"><pre>{{ messageErreurLabel }}</pre></div>

    

  </form>

</template>

<script>
export default {
  name: 'MailjetForm',
  props: {
    urlToShare: {
      type: String,
      default: ''
    },
    mailLabel: String,
    subjectLabel: String,
    messageLabel: String,
    envoyerLabel: String,
    messageSendLabel: String,
    messageErreurLabel: String,
    sendLabel: String,
    sendingLabel: String,
    labelButton: String
  },
  data() {
    return {
      fromEmail: 'partage@r-agency.fr',
      toEmail: '',
      subject: '',
      message: '',
      messagePersonel: '',
      loading: false,
      success: false,
      error: ''
    };
  },
  methods: {
    async sendMail() {
      this.loading = true;
      this.success = false;
      this.error = '';

      this.matricehtml = `
        <p>[messagePersonel]</p>
        <a href="[lien]" 
          style="display:inline-block;padding:12px 32px;background:#010a20;color:#b5d7d6;border-radius:8px;text-decoration:none;font-weight:600;font-size:1.1em;">
          [labelbuttom]
        </a>
      `;
      let messageFinal = this.matricehtml.replace('[messagePersonel]', this.messagePersonel);
      messageFinal = messageFinal.replace('[lien]', this.urlToShare);
      messageFinal = messageFinal.replace('[labelbuttom]', this.labelButton);

      const body = {
        fromEmail: this.fromEmail,
        toEmail: this.toEmail,
        subject: this.subject,
        message: messageFinal
      };

      try {
        const response = await fetch('mailjet-send.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        if (data.success) {
          this.success = true;
          this.fromEmail = '';
          this.toEmail = '';
          this.subject = '';
          this.message = '';

          // Sauvegarde l'envoi du mail dans la base
          this.$store.dispatch('saveActionToMemo', {
            action: 'mail',
            tag: 'to',
            value: body.toEmail
          });
        } else {
          this.error = this.messageErreurLabel;
          // Sauvegarde l'erreur dans la base
          this.$store.dispatch('saveActionToMemo', {
            action: 'mail',
            tag: 'etat',
            value: this.messageErreurLabel
          });
        }
      } catch (e) {
        this.error = this.messageErreurLabel;
        // Sauvegarde l'erreur dans la base
        this.$store.dispatch('saveActionToMemo', {
          action: 'mail',
          tag: 'error',
          value: this.messageErreurLabel
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.mailjet-form {
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 100%;
   color: white !important;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.mailjet-form label {
  font-weight: 500;
  color: var(--colorDark);
}

.mailjet-form input,
.mailjet-form textarea {
  padding: 8px 10px;
  border: 1px solid var(--colorLight);
  border-radius: 6px;
  font-size: 1em;
  transition: border 0.2s;
  background-color: var(--colorLight);
}
.mailjet-form input:focus,
.mailjet-form textarea:focus {
  border-color: var(--colorLight);
  outline: none;
}
.mailjet-form button {
  padding: 10px 0;
  background: var(--colorDark);
  color: var(--colorLight);
  border: none;
  border-radius: 6px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.mailjet-form button:hover {
  background: var(--colorActive);
}
.mailjet-form button:disabled {
  cursor: not-allowed;
}
.success-message {
  color: white;
  font-weight: 500;
  margin-top: 8px;
}
.error-message {
  color: white;
  font-weight: 500;
  margin-top: 8px;
}
</style>